import styled from '@emotion/styled';

const LogoList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  gap: 1.25rem;

  ${({ theme }) => theme.mq('lg')} {
    flex-direction: row;
    gap: 0;
    padding-block: 2.5rem;
  }
`;

const GarantieWrapper = styled.a`
  position: relative;
  height: 5.625rem;
  margin-bottom: 1.25rem;
`;

const MgpWrapper = styled.li`
  height: 5.625rem;
`;

const CarigamiWrapper = styled.li`
  fill: ${({ theme }) => theme.colors.brand.green100};

  svg {
    height: 1.688rem;

    ${({ theme }) => theme.mq('md')} {
      height: 2.375rem;
    }

    ${({ theme }) => theme.mq('lg')} {
      height: 3.063rem;
    }
  }
`;

export { LogoList, GarantieWrapper, MgpWrapper, CarigamiWrapper };
